import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "sector", "sectorField"]
  static values = {
    sectors: Object,
    roles: Object,
    sectorRoles: Array
  }

  connect() {
    this.updateSectors()
  }

  updateSectors() {
    const sectionId = this.hasSectionTarget ? this.sectionTarget.value : Object.keys(this.sectorsValue)[0]
    const role = this.rolesValue[sectionId]
    const needsSector = this.sectorRolesValue.includes(role)
    const sectorOptions = this.sectorsValue[sectionId] || []

    if (this.hasSectorFieldTarget) {
      this.sectorFieldTarget.classList.toggle("hidden", !needsSector)
    }

    if (!this.hasSectorTarget) return

    this.setSectorOptions(sectorOptions, needsSector)
  }

  setSectorOptions(sectorOptions, required) {
    const select = this.sectorTarget
    const blankLabel = "Selecciona una cátedra"

    if (select.tomselect) {
      const tomSelect = select.tomselect
      tomSelect.clear(true)
      tomSelect.clearOptions()
      tomSelect.addOption({ value: "", text: blankLabel })
      sectorOptions.forEach((option) => {
        tomSelect.addOption({ value: String(option.id), text: option.name })
      })
      tomSelect.refreshOptions(false)
    } else {
      select.innerHTML = ""
      select.add(new Option(blankLabel, ""))
      sectorOptions.forEach((option) => {
        select.add(new Option(option.name, option.id))
      })
    }

    select.required = required
  }
}
